module.exports = __webpack_public_path__ + "img/img_customer_student.53846922.svg";